import { NgClass, NgStyle, NgIf } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { Carousel, CarouselModule } from 'primeng/carousel';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu';
import { ScreenSizeService } from '@Shared/services';
import { Subscription } from 'rxjs';
import { LoaderService } from '@Shared/components/loader/loader.service';
import { BusinessDetails, BusinessPitch } from '@App/common/models';
import { CustomerAnalyticsService } from '../../../choosen-history/services';
import { PitchCardTypeEnum } from '@App/common/enums';
import {
  CommonBindingDataService,
  NotificationService
} from '@Shared/services';
import { PitchCardService } from '@App/modules/pitch-card-shared/services';
import { ActivatedRoute } from '@angular/router';
import { BusinessReviewItemComponent } from '@App/modules/pitch-card-shared/components';
import { ProgressBarModule } from 'primeng/progressbar';

@Component({
  selector: 'app-business-reviews',
  templateUrl: './business-reviews.component.html',
  styleUrls: ['./business-reviews.component.scss'],
  standalone: true,
  imports: [
    ProgressBarModule,
    CarouselModule,
    BusinessReviewItemComponent,
    ContextMenuModule,
    NgClass,
    NgStyle,
    NgIf
  ],
  encapsulation: ViewEncapsulation.None
})
export class BusinessReviewsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() business: BusinessPitch | BusinessDetails;
  @Input() isOrganization: boolean = false;

  @Output() leaveReviewClick: EventEmitter<any> = new EventEmitter();

  @Output() showVideo: EventEmitter<any> = new EventEmitter();

  isLoaded = false;
  averageCustomerRating = 0;
  averageQualityRating = 0;
  averageRating = -1;
  reviewsList: any[] = [];
  inlineName = false;
  reportTypes: MenuItem[];
  selectedReview: string;
  numVisible: number;
  limit: number = 3;
  offset: number = 0;
  cacheId: string = '';
  totalRecords: number;
  scaleFactor = 0.85;
  currentUrl: string;
  displayName = '';
  PitchCardTypes = PitchCardTypeEnum;
  responsiveOptions: any;
  isMobile: boolean;
  xDown: number;
  yDown: number;

  $businessReviewSub: Subscription = new Subscription();

  @ViewChild('carousel', { static: false }) carousel: Carousel;
  @ViewChild('menu', { static: true }) menu: ContextMenu;
  @ViewChild('summaryContainer', { static: true })
  summaryContainer: ElementRef;

  constructor(
    private customerAnalyticsService: CustomerAnalyticsService,
    private notificationService: NotificationService,
    private commonBindingDataService: CommonBindingDataService,
    private confirmationService: ConfirmationService,
    private screenSizeService: ScreenSizeService,
    private PCService: PitchCardService,
    private loaderService: LoaderService,
    private activatedRoute: ActivatedRoute
  ) {
    this.onResized = this.onResized.bind(this);
    this.isMobile = this.screenSizeService.isMobile;
    this.reportTypes = [
      {
        label: this.commonBindingDataService.getLabel('label_delete'),
        styleClass: 'delete',
        visible: false,
        id: '1',
        command: () => {
          this.handleDeleteModal();
        }
      },
      {
        label: 'Report',
        id: '2',
        items: [
          {
            label: this.commonBindingDataService.getLabel('lbl_sexual_content'),
            id: '1',
            command: (data) => {
              this.reportIssuesApiCall(data);
            }
          },
          {
            label: this.commonBindingDataService.getLabel(
              'lbl_violent_or_repulsive_content'
            ),
            id: '2',
            command: (data) => {
              this.reportIssuesApiCall(data);
            }
          },
          {
            label: this.commonBindingDataService.getLabel(
              'lbl_hateful_or_abusive_content'
            ),
            id: '3',
            command: (data) => {
              this.reportIssuesApiCall(data);
            }
          },
          {
            label: this.commonBindingDataService.getLabel(
              'lbl_harmfulor_dangerous_acts'
            ),
            id: '4',
            command: (data) => {
              this.reportIssuesApiCall(data);
            }
          },
          {
            label: this.commonBindingDataService.getLabel(
              'lbl_spam_or_misleading'
            ),
            id: '5',
            command: (data) => {
              this.reportIssuesApiCall(data);
            }
          }
        ]
      }
    ];
  }

  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    if (
      this.screenSizeService.isMobile &&
      this.screenSizeService.os === 'IOS' &&
      this.menu
    ) {
      this.menu.hide();
    }
  }

  @HostListener('window:click', ['$event'])
  handleClick(event: any) {
    if (
      event.target.classList.contains('p-carousel-next') ||
      event.target.classList.contains('pi-chevron-right')
    ) {
      this.handleSlideFront();
    }
    if (
      event.target.classList.contains('p-carousel-prev') ||
      event.target.classList.contains('pi-chevron-left')
    ) {
      this.handleSlideBack();
    }
  }

  @HostListener('window:keyup', ['$event'])
  // keyEvent(event: KeyboardEvent) {
  keyEvent(event: any) {
    if (this.carousel) {
      if (event.keyCode === 39) {
        this.carousel.navForward(event);
      }
      if (event.keyCode === 37) {
        this.carousel.navBackward(event);
      }
    }
  }

  ngOnInit(): void {
    this.numVisible = this.PCService.getCarouselVisibleNumbers();
    this.limit = this.numVisible;
    this.responsiveOptions =
      this.PCService.getReviewsCarouselResponsiveOptions();
    window.addEventListener('resize', this.onResized);
    this.onResized();
    this.currentUrl = this.activatedRoute.snapshot['_routerState'].url;
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.onResized);
    if (this.$businessReviewSub) {
      this.$businessReviewSub.unsubscribe();
    }
  }

  onResized() {
    if (this.business) {
      if (this.displayName) {
        this.inlineName =
          document.body.clientWidth / 2 < this.displayName.length * 8.5;
      }
    }
  }

  ngOnChanges() {
    if (this.business) {
      this.loaderService.show();
      this.getBusinessDetails(this.business.id);
      if (this.displayName) {
        this.inlineName =
          document.body.clientWidth / 2 < this.displayName.length * 8.5;
      }
    }
  }

  showReportMenu(event: any) {
    this.selectedReview = event.reviewId;
    this.menu.toggle(event.event);
    this.menu.target = event.event.target;
  }

  focusIn() {}

  showVideoPlayer(event: any) {
    this.showVideo.next(event);
  }

  setRatings({
    customerService,
    quality
  }: {
    customerService: number;
    quality: number;
  }) {
    if (customerService) {
      this.averageCustomerRating = +customerService.toFixed(1);
    }

    if (quality) {
      this.averageQualityRating = +quality.toFixed(1);
    }

    if (customerService || quality) {
      this.averageRating = (+customerService + +quality) / 2;
    }
  }

  enableButtons() {
    setTimeout(() => {
      if (
        this.carousel?.isForwardNavDisabled() ||
        this.carousel?.isBackwardNavDisabled()
      ) {
        const prevBtn = document.getElementsByClassName(
          'p-carousel-prev p-link p-disabled'
        )[0];
        const nextBtn = document.getElementsByClassName(
          'p-carousel-next p-link p-disabled'
        )[0];

        if (prevBtn) {
          prevBtn.removeAttribute('disabled');
          prevBtn.classList.remove('p-disabled');
        }
        if (nextBtn) {
          nextBtn.removeAttribute('disabled');
          nextBtn.classList.remove('p-disabled');
        }
      }
    }, 1000);
  }

  handleSlideFront() {
    if (
      this.offset + this.numVisible > this.totalRecords - this.numVisible &&
      !(this.offset >= this.totalRecords - 1)
    ) {
      this.offset = this.totalRecords - 1;
    } else if (this.offset >= this.totalRecords - 1) {
      this.offset = 0;
    } else {
      this.offset += this.numVisible;
    }
    this.getBusinessDetails(this.business.id);
  }

  handleSlideBack() {
    this.offset = !this.offset
      ? this.totalRecords - 1
      : this.offset - this.numVisible;
    this.getBusinessDetails(this.business.id);
  }

  handleSlideCenter() {
    if (this.reviewsList?.length < this.numVisible) {
      const container = document.getElementsByClassName(
        'p-carousel-items-container'
      ) as HTMLCollection;
      if (container.length) {
        for (let i = 0; i < container.length; i++) {
          if (container[i].className === 'p-carousel-items-container') {
            const node = container[i] as HTMLElement;
            node.style.transform = '';
          }
        }
      }
    }
  }

  addReview() {
    this.leaveReviewClick.emit({
      title: 'leaveareview',
      businessId: this.business.id,
      businessName: this.business.businessName
    });
  }

  getBusinessDetails(businessId: string) {
    this.$businessReviewSub.add(
      this.getBusinessReviewsRoute(businessId).subscribe({
        next: ({ data }) => {
          if (data) {
            this.setRatings(data);
            this.displayName = data?.displayName
              ? data.displayName
              : this.business?.displayName
                ? this.business.displayName
                : '';

            this.reportTypes[0].visible = data.canDelete;
            this.cacheId = data?.cacheId ? data.cacheId : '';
            this.reviewsList = [...data.reviews];
            this.totalRecords = data.count;
          }

          this.loaderService.hide();
          this.isLoaded = true;

          this.enableButtons();
          this.handleSlideCenter();
          if (this.reviewsList.find((r) => r.isNew) && this.isOrganization) {
            this.updateIncomeReviews();
          }
        },
        error: (err) => {
          this.handleErrorMessage(err);
        }
      })
    );
  }

  getBusinessReviewsRoute(businessId: string) {
    const config = this.cacheId
      ? { limit: this.limit, offset: this.offset, cacheId: this.cacheId }
      : { limit: this.limit, offset: this.offset };
    if (this.isOrganization) {
      return this.customerAnalyticsService.getAllBusinessVideoReviewList(
        businessId,
        config
      );
    } else {
      return this.customerAnalyticsService.getBusinessVideoReviewList(
        businessId,
        config
      );
    }
  }

  reportIssuesApiCall(selectedIssue: any) {
    const reviewData = this.reviewsList.find(
      (x) => x.id === this.selectedReview
    );
    const reportTypes = this.reportTypes.find((t) => t.id === '2');
    const issueName = reportTypes.items.find(
      (x) => x.id === selectedIssue.item.id
    ).label;
    this.confirmationService.confirm({
      header: 'Report testimonial',
      icon: 'pi pi-exclamation-triangle',
      message: `Are you sure you want to report ${reviewData.user.firstName} testimonial for ${issueName}?`,
      acceptVisible: true,
      rejectVisible: true,
      acceptLabel: 'Yes',
      accept: () => {
        this.isLoaded = false;
        this.$businessReviewSub.add(
          this.customerAnalyticsService
            .reportIssues(this.business.id, {
              businessCustomerReviewId: this.selectedReview,
              reportedReview: selectedIssue.item.id,
              cacheId: this.cacheId
            })
            .subscribe({
              next: () => {
                this.getBusinessDetails(this.business.id);
              },
              error: (error) => {
                this.handleErrorMessage(error);
              }
            })
        );
      }
    });
  }

  handleDeleteModal() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message:
        'You will not be able to recover this Testimonial once it is deleted.',
      acceptLabel: this.commonBindingDataService.getLabel('label_delete'),
      rejectLabel: 'cancel',
      acceptIcon: '-',
      rejectIcon: '-',
      accept: () => {
        this.isLoaded = false;
        this.loaderService.show();
        this.customerAnalyticsService
          .deleteTestimonial(this.selectedReview, this.cacheId)
          .subscribe({
            next: () => {
              this.getBusinessDetails(this.business.id);
            },
            error: (error) => {
              this.handleErrorMessage(error);
            }
          });
      }
    });
  }

  setTestimonialApprove({ id }: { id: string }) {
    this.loaderService.show();
    this.$businessReviewSub.add(
      this.customerAnalyticsService
        .setApproveTestimonial(id, this.cacheId)
        .subscribe({
          next: () => {
            this.getBusinessDetails(this.business.id);
          },
          error: (error) => {
            this.handleErrorMessage(error);
          }
        })
    );
  }

  updateIncomeReviews() {
    const newReviews: any[] = [...this.reviewsList]
      .filter((r) => r.isNew)
      .map((x) => x.id);
    this.$businessReviewSub.add(
      this.customerAnalyticsService
        .updateNewTestimonials(newReviews, this.cacheId)
        .subscribe({
          next: () => {},
          error: (error) => {
            this.handleErrorMessage(error);
          }
        })
    );
  }

  handleErrorMessage({ message }: { message: string }) {
    this.notificationService.showNotification(
      'ERROR',
      message || this.commonBindingDataService.getLabel('err_server')
    );
  }

  handleTouchStart(e: any) {
    if (this.isMobile || this.screenSizeService.isTablet) {
      const firstTouch = this.getTouches(e)[0];
      this.xDown = firstTouch.clientX;
      this.yDown = firstTouch.clientY;
    }
  }

  getTouches(e: any) {
    return e.touches || e.originalEvent.touches;
  }

  handleTouchMove(evt: any) {
    if (this.isMobile || this.screenSizeService.isTablet) {
      if (!this.xDown || !this.yDown) {
        return;
      }

      const xUp = evt.touches[0].clientX;
      const yUp = evt.touches[0].clientY;

      const xDiff = this.xDown - xUp;
      const yDiff = this.yDown - yUp;

      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        /*most significant*/
        if (xDiff > 0) {
          this.handleSlideFront();
        } else {
          this.handleSlideBack();
        }
      }
      /* reset values */
      this.xDown = null;
      this.yDown = null;
    }
  }
}
